<template>
  <div v-if="time || edited">
    <template v-if="time">{{ time }}</template>
    <span v-if="edited" :class="['p-chat-item__edited', { 'p-chat-item__edited--solo': !time }]">{{
      $t('chat.edited')
    }}</span>
  </div>
</template>

<script setup lang="ts">
// Bir mesaj balonunun alt satırı: saat ve/ve ya "düzenlendi" işareti.
//
// Dört yerde birebir aynı işaretleme vardı (düz metin satırı, resim eki, dosya
// eki ve balonsuz bot varyantı), her biri kendi koşulunu ayrı taşıyordu. Koşul
// da ayraç da burada tek yerde duruyor; çağrı yerlerinde yalnız kendi sınıf
// adları kalıyor (tek kök eleman → `class` doğal olarak birleşiyor).
defineProps<{
  time?: string
  // Ajan mesajı düzenlediyse true. Müşterinin kendi düzenleme yetkisi yok —
  // bu işaret yalnızca ajanın yaptığını gösterir.
  edited?: boolean
}>()
</script>
